import { ButtonHTMLAttributes, forwardRef, useMemo } from "react";
import { IconLoader3 } from "@tabler/icons-react";
import { classNames } from "@ct-react/core";
import "./button.scss";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  processing?: boolean;
}

const Button = forwardRef<HTMLButtonElement, Props>((
  {
    className,
    type = "button",
    children,
    processing,
    ...props
  }: Props, forwardedRef) => {

  const processable = useMemo(() => typeof processing !== "undefined", []);

  const wrapperClasses = classNames("btn", className, {
    "with-process": processable,
    "on-process": !!processing
  });

  return (
    <button ref={forwardedRef}
            type={type}
            className={wrapperClasses}
            {...props}>
      <span className="txt">{children}</span>
      {processable &&
        <span className="loader">
          <IconLoader3 className="l-icon" />
        </span>
      }
    </button>);

});

export default Button;
